// Core
import { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// Components
import { Crumbs, PageHead, SideTabs } from "components/AtomsV2";
import HelpFloatingButtonV2 from "components/HelpFloatingButtonV2";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";

// Pages
import ManageEVBatteryStateLoads from "pages/ManageEVs/EVBatteryStateLoads";
import ManageEVChargingIntervalsForecast from "pages/ManageEVs/ChargingIntervalForecast";
import ManageEVDrivingLoads from "pages/ManageEVs/DrivingLoads";

function ManageEVs() {
  const { t } = useTranslation(["internalLoads", "community", "sidenav"]);
  const community = useSelector(selectCurrentCommunity);
  const [tab, setTab] = useState("state");

  const tabs = [
    { id: "state", icon: "battery_charging_full", label: t("pages.ev_battery_state.title") },
    {
      id: "forecast",
      icon: "ev_station",
      label: t("pages.ev_charging_intervals_forecast.title"),
    },
    { id: "driving", icon: "directions_car", label: t("pages.ev_driving_loads.title") },
  ];

  return (
    <div>
      <HelpFloatingButtonV2 helpScreen="loads" />
      <Crumbs
        items={[
          { label: community?.name || "—" },
          { label: t("internalloads", { ns: "sidenav", defaultValue: "Medições Internas" }) },
          { label: t("sidenav.ev", { ns: "community", defaultValue: "Veículos Elétricos" }) },
        ]}
      />
      <PageHead
        title={t("sidenav.ev", { ns: "community", defaultValue: "Veículos Elétricos" })}
        subtitle={t("pages.ev_battery_state.subtitle")}
      />
      <SideTabs items={tabs} active={tab} onChange={setTab}>
        {tab === "state" && <ManageEVBatteryStateLoads noWrapper />}
        {tab === "forecast" && <ManageEVChargingIntervalsForecast noWrapper />}
        {tab === "driving" && <ManageEVDrivingLoads noWrapper />}
      </SideTabs>
    </div>
  );
}

export default ManageEVs;
